<template>
    <!-- 招聘中心 -->
    <div class="talent">
        <div class="c_banner">
            <img :src="banner" style="width: 100%;" alt="">
            <!-- <div class="text_p_fixed">
                <div class="text_box">
                    <div class="text1">JOIN US</div>
                    <div class="text2">加入我们</div>
                    <div class="text3">让我们一起做得更好！</div>
                </div>
            </div> -->
        </div>
        <div v-if="casenav.length" class="case_box">
            <div class="c_b_nav_c">
                <ul class="c_b_nav_l">
                    <li class="c_b_nav_btn" :class="{'add_c_b_nav_btn' :index==caseactive}"
                        v-for="(item,index) in casenav" :key="index" @click="casenav_func(index)">
                        {{item.cate_name}}
                    </li>
                </ul>
                <ul class="c_b_nav_r">
                    <li class="c_b_nav_r_btn" @click="linkHome">
                        首页 >
                    </li>
                    <li class="c_b_nav_r_btn">
                        人才招聘 >
                    </li>
                    <li class="c_b_nav_r_btn">
                        {{casenav[caseactive].cate_name}}
                    </li>
                </ul>
            </div>

            <!-- 招聘中心 -->
            <div class="c_list_center">
                <ul class="c_l_c_ul" v-show="caseactive == 0" v-for="(item,index) in newsList" :key='index'>
                    <li class="c_l_c_li_title" >
                        {{casenav[0].cate_name}}
                    </li>
                    <li class="c_l_c_li_center">
                        <div v-html="item.news_content"></div>
                    </li>
                </ul>
                <ul class="c_l_c_ul" v-show="caseactive == 1" v-for="(item,index) in newsList" :key='index'>
                    <li class="c_l_c_li_title" >
                        {{casenav[1].cate_name}}
                    </li>
                    <li class="c_l_c_li_center">
                        <div v-html="item.news_content"></div>
                    </li>
                </ul>
                <ul class="c_l_c_ul" v-show="caseactive == 2" v-for="(item,index) in newsList" :key='index'>
                    <li class="c_l_c_li_title" >
                        {{casenav[2].cate_name}}
                    </li>
                    <li class="c_l_c_li_center">
                        <div v-html="item.news_content"></div>
                    </li>
                </ul>


                <!-- <ul class="c_l_c_ul" v-if="casenav[1].showtable">
                  <li class="c_l_c_li_title">
                     员工培训
                  </li>
                  <li class="c_l_c_li_center" style="line-height:40px;text-indent: 2em;">
                      四川华顺源坚持诚信、服务、发展的经营理念，向社会提供优质产品为已任，公司以创品牌为战略目标，坚决走以质量兴业的道路，重培训，抓管理，上台阶，在激烈的市场竞争中立于不败之地。相信在不久的将来，我们企业将在电力行业竖立一座不朽的丰碑。
                        
                        历史铸就现在，现在成就未来。公司将继续坚持“开拓创新、周到服务、科学管理、奉献精品”的服务宗旨，大力推进技术创新、工艺创新和管理创新，重合同、守信誉，为国内外用户建设优质高效的工程并提供周到满意的服务。
                        
                        为推动学习型组织的建设，提高员工的综合素质和业务能力，公司重点从项目管理、商务、经验分享、个人技能及新员工等方面开展培训。

                        公司每年为员工提供众多培训课程，近年来举办的内训如"FIDIC合同条件"、"国际工程索赔最佳实践分享"、"国际工程投标的前期工作"、"项目文件资料管理"、"国际工程见索即付保函及工程保险法律精要及案例分析"、"国际工程项目的经营管理"、"设计采购施工工程项目管理实务"、"国际工程项目安全管理"、"国际工程项目税务及外汇风险管理"、"国际工程项目融资及进出口信贷案例分析"、"INDRAMAYU项目执行经验分享"、"国际工程合同英文函件写作"、"保函"、"信用证"、"PowerPoint 2007商用幻灯片制作"等内训。

                        为了帮助新员工尽快适应公司文化，公司对新员工的培训涵盖了"企业文化"、"公司发展史及概况"、"公司各项规章制度"、"三合一体系管理"、"安全生产知识"、"项目管理程序"、"职业生涯辅导"、"如何从新员工成长为项目经理"、"招投标管理"、"拓展培训"等多个方面，并为新员工配备导师。

                        目前，公司已初步形成了内训与外训相结合，定制课程与标准课程相补充，分梯队、分层次、分系列的培训体系，为公司的人才培养搭建了一个良好的平台。

                        公司倡导"才能在实干中展现，价值在贡献里提升"的人才理念，孜孜追求更好地提升各类人员能力与素质的有效手段与方法，不断努力改进和完善培训体系。
                  </li>
              </ul>
                   <ul class="c_l_c_ul" v-if="casenav[2].showtable">
                  <li class="c_l_c_li_title">
                     招聘职位
                  </li>
                  <li class="c_l_c_li_center">
                      <div class="talent_title_b">
                          <div class="talent_title_text1">四川华顺源建设工程有限公司</div>
                          <div class="talent_title_text2">2020年校园招聘计划</div>
                      </div>
                      <table class="talent_table">
                          <tr>
                            <th>序号</th>
                            <th>招聘岗位</th>
                            <th>所需专业</th>
                            <th>学历</th>
                          </tr>
                          <tr v-for="(item,index) in 8" :key="index">
                            <td>{{item}}</td>
                            <td>市场营销</td>
                            <td>市场管理</td>
                            <td>本科</td>
                          </tr>
                      </table>
                  </li>
              </ul> -->
            </div>
        </div>
        <div style="margin-bottom: 206px;"></div>
    </div>
</template>

<script>
    import {
        getNewsList,
        getNavList
    } from '../../api/apis.js'
    export default {
        name: 'Talent',
        data() {
            return {
                banner:"",
                //分页
                page: {
                    current_page: 0,
                    limit: 12,
                    last_page: 1,
                    total: ''
                },
                showlistb: true,
                newsList: [],
                caseactive: 0,
                casenav: [
                    //   {'id':0,'title':'人才结构','showtable':true},
                    //   {'id':1,'title':'员工培养','showtable':false},
                    //   {'id':2,'title':'招聘职位','showtable':false}
                ]
            }
        },
        components: {

        },
        mounted() {
            getNavList().then(res => {
                let navBanner = [];
                let cate = [];
                let navList = [
                    { id: 0, title: "首页", path: "/" },
                    { id: 0, title: "业务范围", path: "/busines" },
                    { id: 0, title: "公司简介", path: "/brief" },
                    { id: 0, title: "工程案例", path: "/casecenter" },
                    { id: 0, title: "新闻中心", path: "/newscenter" },
                    { id: 0, title: "人才招聘", path: "/talent" },
                    { id: 0, title: "联系我们", path: "/concat" }
                ];
                res.forEach((item, index) => {
                    navList[index].id = item.id;
                    navList[index].title = item.cate_name;
                    navBanner[index] = item.cate_img;
                    cate.push(item.next_cate);
                });
                this.banner = navBanner[5]
                this.casenav = cate[5];
                this.getList();
            })
        },
        methods: {
            linkHome(){
                this.$router.push({path:'/'})
            },
            //改变路由按钮颜色
            casenav_func(index) {
                this.caseactive = index;
                this.initPage();
             
                //请求新闻列表
                this.getList();
            },
            getList() {
                let index = this.caseactive;
                console.log('index2',index);
                if (this.page.current_page < this.page.last_page) {
                    this.page.current_page = ++this.page.current_page;
                    getNewsList({
                        pid: this.casenav[index].pid,
                        page: this.page.current_page,
                        limit: this.page.limit
                    }).then(res => {
                        this.newsList = this.newsList.concat(res.data);
                        let page = {
                            current_page: res.current_page,
                            limit: 12,
                            last_page: res.last_page,
                            total: res.total
                        };
                        this.page = page;
                    })

                }
            },
            //初始化page
            initPage() {
                this.page = {
                    current_page: 0,
                    limit: 12,
                    last_page: 1,
                };
                this.newsList = [];
            },
            //显示案例详情
            //   navtocaselist(e,id){
            //       this.showlistb = !this.showlistb;
            //        switch(this.caseactive){
            //           case 0:
            //                this.$refs.caselist.getindex('返回公司新闻',this.caseactive,id);
            //             break;
            //           case 1:
            //                this.$refs.caselist.getindex('返回行业新闻',this.caseactive,id);
            //             break;
            //           default:
            //             break;
            //       }
            //   },
            //接受子组件参数，返回上一级；
            //   gotohistory(data){
            //       if(data){
            //            this.showlistb=true;
            //       }
            //   }
        },
    }
</script>
<style scoped lang="scss">
    body,
    html {
        background: #F2F2F2;

    }

    .talent {
        // border:1px solid red;
        background: #F2F2F2;
        width: 100%;

        .c_banner {
            border-top: 1px solid #ffffff;
            /* height: 500px; */
            width: 100%;
            min-width: 1200px;
            margin: 0 auto;
            /* background: url('../../assets/c4.png') no-repeat; */
            background-size: 100% 500px;

            .text_p_fixed {
                //  border:1px solid red;
                width: 1200px;
                height: 500px;
                margin: 0 auto;

                .text_box {
                    //  border:1px solid red;
                    width: 870px;
                    height: 200px;
                    margin-left: 180px;
                    margin-top: 104px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;

                    .text1 {
                        // border:1px solid red;
                        width: 212px;
                        font-size: 48px;
                        font-family: 迷你简综艺;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 1);
                        opacity: 1;
                        line-height: 48px;
                    }

                    .text2 {
                        // border:1px solid red;
                        width: 298px;
                        height: 72px;
                        font-size: 72px;
                        font-family: 迷你简菱心;
                        font-weight: 400;
                        line-height: 72px;
                        color: rgba(255, 255, 255, 1);
                        opacity: 1;
                    }

                    .text3 {
                        width: 292px;
                        height: 49px;
                        background: rgba(255, 255, 255, 1);
                        opacity: 1;

                        // height:31px;
                        font-size: 20px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 49px;
                        color: #8B8E9D;
                        text-align: center;
                    }
                }
            }
        }

        .case_box {
            // border:1px solid yellow;
            width: 1200px;
            // height: 1200px;
            margin: 0 auto;

            .c_b_nav_c {
                //  border:1px solid red;
                width: 1200px;
                height: 64px;
                background: #ffffff;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .c_b_nav_l {
                    // border:1px solid red;
                    // width: 640px;
                    height: 64px;
                    display: flex;
                    justify-content: space-between;

                    .c_b_nav_btn {
                        //  border:1px solid red;
                        width: 160px;
                        height: 64px;
                        font-size: 18px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 64px;
                        text-align: center;
                        color: rgba(102, 102, 102, 1);
                        opacity: 1;
                        cursor: pointer;
                    }

                    .c_b_nav_btn:hover {
                        color: #ffffff;
                        background: #1584F5;
                    }

                    .add_c_b_nav_btn {
                        color: #ffffff;
                        background: #1584F5;
                    }
                }

                .c_b_nav_r {
                    display: flex;
                    justify-content: space-around;
                    color: #999999;
                    font-size: 16px;
                    margin-right: 15px;

                    .c_b_nav_r_btn {
                        cursor: pointer;
                    }
                }

            }

            .c_list_center {
                // border:1px solid red;
                width: 1200px;
                background: #ffffff;

                .c_l_c_ul {
                    border: 1px solid #ffffff;
                    margin-top: 20px;

                    .c_l_c_li_title {
                        border-left: 6px solid #1B5BA0;
                        width: 170px;
                        height: 42px;
                        font-size: 32px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 42px;
                        color: rgba(27, 91, 160, 1);
                        opacity: 1;
                        text-align: center;
                        margin-top: 20px;
                        margin-left: 20px;

                    }

                    .c_l_c_li_center {
                        //  border:1px solid red;
                        width: 900px;
                        // height: 100px;
                        font-size: 16px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 28px;
                        color: rgba(51, 51, 51, 1);
                        opacity: 1;
                        margin: 0 auto;
                        margin-top: 20px;
                        margin-bottom: 30px;

                        .talent_title_b {
                            //  border:1px solid red;
                            margin: 0 auto;
                            display: flex;
                            justify-content: space-around;
                            align-items: center;
                            flex-direction: column;

                            .talent_title_text1 {
                                width: 435px;
                                height: 42px;
                                font-size: 32px;
                                font-family: Microsoft YaHei;
                                font-weight: 400;
                                line-height: 28px;
                                color: rgba(51, 51, 51, 1);
                                opacity: 1;
                            }

                            .talent_title_text2 {
                                width: 177px;
                                height: 24px;
                                font-size: 18px;
                                font-family: Microsoft YaHei;
                                font-weight: 400;
                                line-height: 28px;
                                color: rgba(153, 153, 153, 1);
                                opacity: 1;
                            }
                        }

                        .talent_table {
                            border: 1px solid #000000;
                            width: 100%;
                            margin-top: 40px;

                            tr {
                                border: 1px solid #000000;
                            }

                            th {
                                border: 1px solid #000000;
                                text-align: center;
                            }

                            td {
                                border: 1px solid #000000;
                                font-size: 16px;
                                font-family: Microsoft YaHei;
                                font-weight: 400;
                                line-height: 28px;
                                font-size: 16px;
                                color: rgba(51, 51, 51, 1);
                                opacity: 1;
                                text-align: center;
                            }
                        }
                    }

                    .c_l_c_li {}
                }
            }
        }
    }
</style>